import { Navigate } from "react-router-dom";

import { useUsers } from "~/hooks";
import { ROUTES } from "~/router";
import { useResolveRedirection } from "~/shared/utils";
import { useAuthStore } from "~/stores";

export const HomeRedirect = () => {
  const { getCurrentUser } = useUsers();
  const accessToken = useAuthStore((state) => state.accessToken);
  const { data: currentUser, isLoading } = getCurrentUser(!!accessToken);

  useResolveRedirection(currentUser);

  if (isLoading) {
    return null;
  }

  if (!currentUser) {
    return <Navigate to={ROUTES.fullLogin} replace />;
  }

  return null;
};
